/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */

'use strict';
const searchPartMixin = require('../modules/mixins/searchpart.mixin');
const {isCssVariationHeaderDesktop} = Odigeo.AB;
const {tap, fake, change} = Odigeo.Events;

Odigeo.defineWidget('oneline_cabinclass', Odigeo.Widget.extend({
    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
    },
    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        bindCustomEvents: function(searchModel) {
            this.searchModel = searchModel;
        },
    })),
    viewClass: Odigeo.View.extend({

        selectors: {
            cabinClass: '#oneline-cabin-class',
            cabinClassValue: '.classselector_value',
            cabinClassDropdownIcon: '.classselector_dropdown_arrow',
        },

        init: function() {
            const cabinClass = this.$cachedSelectors.cabinClass;

            if (!isCssVariationHeaderDesktop) {
                Odigeo.UIElements.enhanceSwitcher(cabinClass);
            }
            this.listenTo(this.model, 'sync:fetch', this.onDataFromStorageReady);

            if (!isCssVariationHeaderDesktop) {
                cabinClass.on(change, Odigeo._.bind(this.onChangeCabinClass, this));
            } else {
                cabinClass.on(tap, Odigeo._.bind(this.onToggleCabinClass, this));
                cabinClass.find('li').on(tap, Odigeo._.bind(this.onSelectCabinClass, this));
                this.listenTo(fake, 'fake:blur', function(e) {
                    if (cabinClass.hasClass('focus') && !cabinClass.get(0).contains(e.target)) {
                        this.toogleCabinClassSelector();
                    }
                });
            }
        },

        onDataFromStorageReady: function() {
            const searchSegments = this.model.searchModel.get('searchSegments');
            if (!Odigeo._.isUndefined(searchSegments)) {
                if (!isCssVariationHeaderDesktop) {
                    this.setCabinClassValue(this.model.searchModel.get('cabinClass'));
                } else {
                    const option = this.$cachedSelectors.cabinClass.find('li[data-value="' + this.model.searchModel.get('cabinClass') + '"]');
                    this.setCabinClassValueCobalt(option);
                }
            }
        },

        setCabinClassValue: function(value) {
            const cabinClass = this.$cachedSelectors.cabinClass;
            const modelValue = Odigeo._.isUndefined(value) ? cabinClass.find('option:selected').val() : value;
            const textVal = Odigeo._.isUndefined(value)
                ? cabinClass.find('option:selected').text()
                : cabinClass.find('[value="' + value + '"]').text();

            this.$cachedSelectors.cabinClassValue.text(textVal);
            this.model.searchModel.set('cabinClass', modelValue);
        },

        setCabinClassValueCobalt: function(option) {
            if (!Odigeo._.isUndefined(option)) {
                this.$cachedSelectors.cabinClass.find('li.selected').removeClass('selected');
                option.addClass('selected');
                this.$cachedSelectors.cabinClassValue.text(option.text());
                this.model.searchModel.set('cabinClass', option.data('value'));
            }
        },

        toogleCabinClassSelector: function() {
            const cabinClass = this.$cachedSelectors.cabinClass;
            const cabinClassIcon = this.$cachedSelectors.cabinClassDropdownIcon;

            cabinClass.toggleClass('focus', !cabinClass.hasClass('focus'));
            cabinClassIcon.toggleClass('odf-icon-arrow-down', !cabinClass.hasClass('focus'));
            cabinClassIcon.toggleClass('odf-icon-arrow-up', cabinClass.hasClass('focus'));
        },

        onToggleCabinClass: function() {
            this.toogleCabinClassSelector();
        },

        onSelectCabinClass: function(event) {
            event.stopPropagation();
            const option = $(event.currentTarget);

            this.setCabinClassValueCobalt(option);
        },

        onChangeCabinClass: function() {
            this.setCabinClassValue();
        },
    }),
}));
